module.exports = __webpack_public_path__ + "static/white-29fcae6ae9f8c10e2e22693865f70e7c.png";